import styled from "styled-components";

import LabelSection from "src/components/core/LabelSection";
import Dropdown from "src/components/core/Dropdown";

import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { MoreHoriz, Edit } from "@mui/icons-material";

import BannerHomeEditDialog from "./BannerHomeEditDialog";

import { useDialog } from "src/context/DialogContext";

import { Black, White } from "src/styles/color";
import { hexToRgba } from "src/common/color";

import useBanner from "src/hooks/useBanner";

const S = {};

S.BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

S.BannerListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

S.BannerItemWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: calc(100% / (1250 / 280));
  background-color: #f3f1f2;
  border-radius: 16px;
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: center;
`;

S.HoverContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: 0;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
`;

S.ItemBackdrop = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 16px;
`;

S.ItemActionMenu = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 8px;
`;

const BannerHome = () => {
  //   const [banners, setBanners] = useState([]);
  const { banners, fetchBanners, toggleVisibility } = useBanner({
    bannerKey: "shop_this_moods",
    resource: "homepage",
  });

  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const item = banners[0];

  return (
    <S.BoxWrapper>
      <LabelSection title="แบนเนอร์ช้อปเพลินทุกสไตล์">
        {item && (
          <S.BannerItemWrapper $backgroundImage={item?.image}>
            {!item?.is_public && (
              <S.ItemBackdrop>
                <VisibilityOffIcon
                  sx={{
                    color: White,
                  }}
                />
              </S.ItemBackdrop>
            )}
            <S.HoverContainer>
              {item?.is_public && <S.ItemBackdrop />}
              <S.ItemActionMenu>
                <Dropdown
                  renderButton={(props) => (
                    <IconButton
                      sx={{
                        color: White,
                        backgroundColor: hexToRgba(White, 0.4),
                      }}
                      {...props}
                    >
                      <MoreHoriz />
                    </IconButton>
                  )}
                  options={[
                    {
                      label: "แก้ไข",
                      startIcon: <Edit />,
                      onClick: () => {
                        openDialog({
                          type: "custom",
                          customDialog: (
                            <BannerHomeEditDialog
                              initialValue={item}
                              onClose={() => closeDialog()}
                              onSuccess={() => {
                                fetchBanners();
                                closeAllDialogs();
                              }}
                            />
                          ),
                        });
                      },
                    },
                    {
                      label: item?.is_public ? "ซ่อน" : "แสดง",
                      startIcon: item?.is_public ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      ),
                      onClick: () => {
                        openDialog({
                          type: "confirm",
                          title: `คุณต้องการ${
                            item?.is_public ? "ปิด" : "เปิด"
                          }การมองเห็นใช่หรือไม่?`,
                          onConfirm: async () => {
                            await toggleVisibility(item?.position);
                            fetchBanners();
                          },
                          maxWidth: 342,
                        });
                      },
                    },
                  ]}
                />
              </S.ItemActionMenu>
            </S.HoverContainer>
          </S.BannerItemWrapper>
        )}

        {/* <Typography
          sx={{
            mt: 3,
            alignSelf: "center",
            fontSize: font.size.sm,
            color: DarkGrey,
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <InfoRounded
            sx={{
              color: Yellow,
              mr: 0.5,
            }}
          />{" "}
          เพิ่มแบนเนอร์ได้สูงสุด 12 รูป ขนาดไฟล์ 1440x540 px ไม่เกิน 4 MB
        </Typography> */}
      </LabelSection>
    </S.BoxWrapper>
  );
};

export default BannerHome;
